import StravaConnect from "./StravaConnect";

export default StravaConnect;
